import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";

import Loading from "../blocks/loading/Loading";
import HomeHeader from "../blocks/header/HomeHeader";
import Footer from "../blocks/footer/Footer";

import PageTitleHome from "../blocks/page-title/PageTitleHome";
import ServicesHome from "../blocks/services/ServicesHome";
import AboutsUs from "../blocks/about/AboutUs";
import HowWorks from "../blocks/how-it-works/HowWorks";
import Clients from "../blocks/clients/Clients";
import Testimonials from "../blocks/testimonials/Testimonials";
import News from "../blocks/news/News";
import ContactsUs from "../blocks/contacts/ContactUs";

const Home = () => {
  document.body.classList.add("home");
  document.body.classList.add("header-absolute-true");
  document.body.classList.add("header-fixed-true");

  return (
    <Fragment>
      <MetaTags>
        <meta charSet="UTF-8" />
        <title>Home | Z3 Info Systems</title>

        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="robots" content="index, follow, noodp" />
        <meta name="googlebot" content="index, follow" />
        <meta name="google" content="notranslate" />
        <meta name="format-detection" content="telephone=no" />
      </MetaTags>

      <Loading />

      <HomeHeader logoColor="light" />

      <main id="main" className="site-main content-no-spacing">
        <div className="content">
          <div className="clearfix">
            <PageTitleHome />

            <ServicesHome />

            <section id="about-us" className="block spacer p-top-xl-2">
              <AboutsUs />
            </section>

           
             <Testimonials />
             <Clients /> 
             
            {/* <div id="clients" className="block bg-white spacer m-top-xs">
            
            </div>  */}

            

            <News />

            <ContactsUs />
          </div>
        </div>
      </main>

      <Footer />
    </Fragment>
  );
};

export default Home;
